<template>
  <v-card>
    <v-card-title class="subtitle-1">
      {{ $t('dialogs.settings.changeYourSettings') }}
    </v-card-title>

    <v-card-text>
      {{ $t('dialogs.settings.settingsDesc') }}
    </v-card-text>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container fluid>
        <v-row>
          <v-col justify="center" cols="12" sm="12">
            <v-btn
              v-if="allowGeo"
              class="ma-2"
              :loading="buttonLoading"
              :disabled="buttonLoading"
              color="info"
              @click="getLocation"
            >
              {{ $t('dialogs.settings.fillForm') }}
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model="longitude" :label="$t('common.terms.longitude')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model="latitude" :label="$t('common.terms.latitude')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model="location" :label="$t('common.terms.townCity')"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field v-model="region" :label="$t('common.terms.stateCountyProvince')">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-select
              v-model="country"
              :items="countryItems"
              item-text="name"
              item-value="code"
              :label="$t('common.terms.country')"
            />
          </v-col>
          <v-col cols="12" cm="6" md="6">
            <v-select v-model="currentLang" :items="languages" :label="$t('common.terms.language')">
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-select
              v-model="currency"
              :items="currencyItems"
              item-text="name"
              item-value="code"
              :label="$t('common.terms.currency')"
            />
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="timezone"
              :label="$t('common.terms.timezone')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row cols="12" sm="12">
          <v-col>
            <v-select
              v-model="background"
              :items="backgroundItems"
              item-text="name"
              item-value="code"
              :label="$t('common.terms.background')"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="red darken-1" text @click="dismiss">
        {{ $t('dialogs.settings.btnDismiss') }}
      </v-btn>

      <v-btn color="green darken-1" text @click="update">
        {{ $t('dialogs.settings.btnUpdate') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      allowGeo: true,
      valid: true,
      longitude: this.$attrs.settings.longitude || null,
      latitude: this.$attrs.settings.latitude || null,
      location: this.$attrs.settings.location || null,
      region: this.$attrs.settings.region || null,
      background: this.$attrs.settings.isBlack || false,
      backgroundItems: [
        { code: false, name: this.$i18n.t('common.terms.photoBackground') },
        { code: true, name: this.$i18n.t('common.terms.blackBackground') }
      ],
      country: this.$attrs.settings.country || null,
      countryItems: [
        { code: 'US', name: 'United States' },
        { code: 'GB', name: 'United Kingdom' },
        { code: 'DE', name: 'Germany' },
        { code: 'IE', name: 'Ireland' },
        { code: '-', name: '------------------' },
        { code: 'AF', name: 'Afghanistan' },
        { code: 'AX', name: '\u00c5land Islands' },
        { code: 'AL', name: 'Albania' },
        { code: 'DZ', name: 'Algeria' },
        { code: 'AS', name: 'American Samoa' },
        { code: 'AD', name: 'Andorra' },
        { code: 'AO', name: 'Angola' },
        { code: 'AI', name: 'Anguilla' },
        { code: 'AQ', name: 'Antarctica' },
        { code: 'AG', name: 'Antigua and Barbuda' },
        { code: 'AR', name: 'Argentina' },
        { code: 'AM', name: 'Armenia' },
        { code: 'AW', name: 'Aruba' },
        { code: 'AU', name: 'Australia' },
        { code: 'AT', name: 'Austria' },
        { code: 'AZ', name: 'Azerbaijan' },
        { code: 'BS', name: 'Bahamas' },
        { code: 'BH', name: 'Bahrain' },
        { code: 'BD', name: 'Bangladesh' },
        { code: 'BB', name: 'Barbados' },
        { code: 'BY', name: 'Belarus' },
        { code: 'BE', name: 'Belgium' },
        { code: 'BZ', name: 'Belize' },
        { code: 'BJ', name: 'Benin' },
        { code: 'BM', name: 'Bermuda' },
        { code: 'BT', name: 'Bhutan' },
        { code: 'BO', name: 'Bolivia' },
        { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
        { code: 'BA', name: 'Bosnia and Herzegovina' },
        { code: 'BW', name: 'Botswana' },
        { code: 'BV', name: 'Bouvet Island' },
        { code: 'BR', name: 'Brazil' },
        { code: 'IO', name: 'British Indian Ocean Territory' },
        { code: 'BN', name: 'Brunei Darussalam' },
        { code: 'BG', name: 'Bulgaria' },
        { code: 'BF', name: 'Burkina Faso' },
        { code: 'BI', name: 'Burundi' },
        { code: 'KH', name: 'Cambodia' },
        { code: 'CM', name: 'Cameroon' },
        { code: 'CA', name: 'Canada' },
        { code: 'CV', name: 'Cape Verde' },
        { code: 'KY', name: 'Cayman Islands' },
        { code: 'CF', name: 'Central African Republic' },
        { code: 'TD', name: 'Chad' },
        { code: 'CL', name: 'Chile' },
        { code: 'CN', name: 'China' },
        { code: 'CX', name: 'Christmas Island' },
        { code: 'CC', name: 'Cocos (Keeling) Islands' },
        { code: 'CO', name: 'Colombia' },
        { code: 'KM', name: 'Comoros' },
        { code: 'CG', name: 'Congo' },
        { code: 'CD', name: 'Congo, Democratic Republic' },
        { code: 'CK', name: 'Cook Islands' },
        { code: 'CR', name: 'Costa Rica' },
        { code: 'CI', name: 'C\u00f4te d\'Ivoire' },
        { code: 'HR', name: 'Croatia' },
        { code: 'CU', name: 'Cuba' },
        { code: 'CW', name: 'Cura\u00e7ao' },
        { code: 'CY', name: 'Cyprus' },
        { code: 'CZ', name: 'Czech Republic' },
        { code: 'DK', name: 'Denmark' },
        { code: 'DJ', name: 'Djibouti' },
        { code: 'DM', name: 'Dominica' },
        { code: 'DO', name: 'Dominican Republic' },
        { code: 'EC', name: 'Ecuador' },
        { code: 'EG', name: 'Egypt' },
        { code: 'SV', name: 'El Salvador' },
        { code: 'GQ', name: 'Equatorial Guinea' },
        { code: 'ER', name: 'Eritrea' },
        { code: 'EE', name: 'Estonia' },
        { code: 'ET', name: 'Ethiopia' },
        { code: 'FK', name: 'Falkland Islands (Malvinas)' },
        { code: 'FO', name: 'Faroe Islands' },
        { code: 'FJ', name: 'Fiji' },
        { code: 'FI', name: 'Finland' },
        { code: 'FR', name: 'France' },
        { code: 'GF', name: 'French Guiana' },
        { code: 'PF', name: 'French Polynesia' },
        { code: 'TF', name: 'French Southern Territories' },
        { code: 'GA', name: 'Gabon' },
        { code: 'GM', name: 'Gambia' },
        { code: 'GE', name: 'Georgia' },
        { code: 'GH', name: 'Ghana' },
        { code: 'GI', name: 'Gibraltar' },
        { code: 'GR', name: 'Greece' },
        { code: 'GL', name: 'Greenland' },
        { code: 'GD', name: 'Grenada' },
        { code: 'GP', name: 'Guadeloupe' },
        { code: 'GU', name: 'Guam' },
        { code: 'GT', name: 'Guatemala' },
        { code: 'GG', name: 'Guernsey' },
        { code: 'GN', name: 'Guinea' },
        { code: 'GW', name: 'Guinea-Bissau' },
        { code: 'GY', name: 'Guyana' },
        { code: 'HT', name: 'Haiti' },
        { code: 'HM', name: 'Heard Island and McDonald Islands' },
        { code: 'VA', name: 'Holy See (Vatican City State)' },
        { code: 'HN', name: 'Honduras' },
        { code: 'HK', name: 'Hong Kong' },
        { code: 'HU', name: 'Hungary' },
        { code: 'IS', name: 'Iceland' },
        { code: 'IN', name: 'India' },
        { code: 'ID', name: 'Indonesia' },
        { code: 'IR', name: 'Iran, Islamic Republic of' },
        { code: 'IQ', name: 'Iraq' },
        { code: 'IM', name: 'Isle of Man' },
        { code: 'IL', name: 'Israel' },
        { code: 'IT', name: 'Italy' },
        { code: 'JM', name: 'Jamaica' },
        { code: 'JP', name: 'Japan' },
        { code: 'JE', name: 'Jersey' },
        { code: 'JO', name: 'Jordan' },
        { code: 'KZ', name: 'Kazakhstan' },
        { code: 'KE', name: 'Kenya' },
        { code: 'KI', name: 'Kiribati' },
        { code: 'KP', name: 'Korea, Democratic People\'s Republic of' },
        { code: 'KR', name: 'Korea, Republic of' },
        { code: 'KW', name: 'Kuwait' },
        { code: 'KG', name: 'Kyrgyzstan' },
        { code: 'LA', name: 'Lao People\'s Democratic Republic' },
        { code: 'LV', name: 'Latvia' },
        { code: 'LB', name: 'Lebanon' },
        { code: 'LS', name: 'Lesotho' },
        { code: 'LR', name: 'Liberia' },
        { code: 'LY', name: 'Libya' },
        { code: 'LI', name: 'Liechtenstein' },
        { code: 'LT', name: 'Lithuania' },
        { code: 'LU', name: 'Luxembourg' },
        { code: 'MO', name: 'Macao' },
        { code: 'MK', name: 'Macedonia' },
        { code: 'MG', name: 'Madagascar' },
        { code: 'MW', name: 'Malawi' },
        { code: 'MY', name: 'Malaysia' },
        { code: 'MV', name: 'Maldives' },
        { code: 'ML', name: 'Mali' },
        { code: 'MT', name: 'Malta' },
        { code: 'MH', name: 'Marshall Islands' },
        { code: 'MQ', name: 'Martinique' },
        { code: 'MR', name: 'Mauritania' },
        { code: 'MU', name: 'Mauritius' },
        { code: 'YT', name: 'Mayotte' },
        { code: 'MX', name: 'Mexico' },
        { code: 'FM', name: 'Micronesia,' },
        { code: 'MD', name: 'Moldova,' },
        { code: 'MC', name: 'Monaco' },
        { code: 'MN', name: 'Mongolia' },
        { code: 'ME', name: 'Montenegro' },
        { code: 'MS', name: 'Montserrat' },
        { code: 'MA', name: 'Morocco' },
        { code: 'MZ', name: 'Mozambique' },
        { code: 'MM', name: 'Myanmar' },
        { code: 'NA', name: 'Namibia' },
        { code: 'NR', name: 'Nauru' },
        { code: 'NP', name: 'Nepal' },
        { code: 'NL', name: 'Netherlands' },
        { code: 'NC', name: 'New Caledonia' },
        { code: 'NZ', name: 'New Zealand' },
        { code: 'NI', name: 'Nicaragua' },
        { code: 'NE', name: 'Niger' },
        { code: 'NG', name: 'Nigeria' },
        { code: 'NU', name: 'Niue' },
        { code: 'NF', name: 'Norfolk Island' },
        { code: 'MP', name: 'Northern Mariana Islands' },
        { code: 'NO', name: 'Norway' },
        { code: 'OM', name: 'Oman' },
        { code: 'PK', name: 'Pakistan' },
        { code: 'PW', name: 'Palau' },
        { code: 'PS', name: 'Palestine' },
        { code: 'PA', name: 'Panama' },
        { code: 'PG', name: 'Papua New Guinea' },
        { code: 'PY', name: 'Paraguay' },
        { code: 'PE', name: 'Peru' },
        { code: 'PH', name: 'Philippines' },
        { code: 'PN', name: 'Pitcairn' },
        { code: 'PL', name: 'Poland' },
        { code: 'PT', name: 'Portugal' },
        { code: 'PR', name: 'Puerto Rico' },
        { code: 'QA', name: 'Qatar' },
        { code: 'RE', name: 'R\u00e9union' },
        { code: 'RO', name: 'Romania' },
        { code: 'RU', name: 'Russian Federation' },
        { code: 'RW', name: 'Rwanda' },
        { code: 'BL', name: 'Saint Barth\u00e9lemy' },
        { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
        { code: 'KN', name: 'Saint Kitts and Nevis' },
        { code: 'LC', name: 'Saint Lucia' },
        { code: 'MF', name: 'Saint Martin (French part)' },
        { code: 'PM', name: 'Saint Pierre and Miquelon' },
        { code: 'VC', name: 'Saint Vincent and the Grenadines' },
        { code: 'WS', name: 'Samoa' },
        { code: 'SM', name: 'San Marino' },
        { code: 'ST', name: 'Sao Tome and Principe' },
        { code: 'SA', name: 'Saudi Arabia' },
        { code: 'SN', name: 'Senegal' },
        { code: 'RS', name: 'Serbia' },
        { code: 'SC', name: 'Seychelles' },
        { code: 'SL', name: 'Sierra Leone' },
        { code: 'SG', name: 'Singapore' },
        { code: 'SX', name: 'Sint Maarten (Dutch part)' },
        { code: 'SK', name: 'Slovakia' },
        { code: 'SI', name: 'Slovenia' },
        { code: 'SB', name: 'Solomon Islands' },
        { code: 'SO', name: 'Somalia' },
        { code: 'ZA', name: 'South Africa' },
        { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
        { code: 'SS', name: 'South Sudan' },
        { code: 'ES', name: 'Spain' },
        { code: 'LK', name: 'Sri Lanka' },
        { code: 'SD', name: 'Sudan' },
        { code: 'SR', name: 'Suriname' },
        { code: 'SJ', name: 'Svalbard and Jan Mayen' },
        { code: 'SZ', name: 'Swaziland' },
        { code: 'SE', name: 'Sweden' },
        { code: 'CH', name: 'Switzerland' },
        { code: 'SY', name: 'Syrian Arab Republic' },
        { code: 'TW', name: 'Taiwan, Province of China' },
        { code: 'TJ', name: 'Tajikistan' },
        { code: 'TZ', name: 'Tanzania' },
        { code: 'TH', name: 'Thailand' },
        { code: 'TL', name: 'Timor-Leste' },
        { code: 'TG', name: 'Togo' },
        { code: 'TK', name: 'Tokelau' },
        { code: 'TO', name: 'Tonga' },
        { code: 'TT', name: 'Trinidad and Tobago' },
        { code: 'TN', name: 'Tunisia' },
        { code: 'TR', name: 'Turkey' },
        { code: 'TM', name: 'Turkmenistan' },
        { code: 'TC', name: 'Turks and Caicos Islands' },
        { code: 'TV', name: 'Tuvalu' },
        { code: 'UG', name: 'Uganda' },
        { code: 'UA', name: 'Ukraine' },
        { code: 'AE', name: 'United Arab Emirates' },
        { code: 'UM', name: 'United States Minor Outlying Islands' },
        { code: 'UY', name: 'Uruguay' },
        { code: 'UZ', name: 'Uzbekistan' },
        { code: 'VU', name: 'Vanuatu' },
        { code: 'VE', name: 'Venezuela, Bolivarian Republic of' },
        { code: 'VN', name: 'Viet Nam' },
        { code: 'VG', name: 'Virgin Islands, British' },
        { code: 'VI', name: 'Virgin Islands, U.S.' },
        { code: 'WF', name: 'Wallis and Futuna' },
        { code: 'EH', name: 'Western Sahara' },
        { code: 'YE', name: 'Yemen' },
        { code: 'ZM', name: 'Zambia' },
        { code: 'ZW', name: 'Zimbabw' }
      ],
      timezone: this.$attrs.settings.timezone || null,
      currentLang: this.$attrs.settings.userLang || null,
      currency: this.$attrs.settings.currency || 'USD',
      currencyItems: [
        { name: 'United States Dollar', code: 'USD' },
        { name: 'Euro', code: 'EUR' },
        { name: 'United Kingdom Pound', code: 'GBP' },
        { name: 'Albania Lek', code: 'ALL' },
        { name: 'Afghanistan Afghani', code: 'AFN' },
        { name: 'Argentina Peso', code: 'ARS' },
        { name: 'Aruba Guilder', code: 'AWG' },
        { name: 'Australia Dollar', code: 'AUD' },
        { name: 'Azerbaijan Manat', code: 'AZN' },
        { name: 'Bahamas Dollar', code: 'BSD' },
        { name: 'Barbados Dollar', code: 'BBD' },
        { name: 'Belarus Ruble', code: 'BYN' },
        { name: 'Belize Dollar', code: 'BZD' },
        { name: 'Bermuda Dollar', code: 'BMD' },
        { name: 'Bolivia Bolíviano', code: 'BOB' },
        { name: 'Bosnia and Herzegovina Convertible Marka', code: 'BAM' },
        { name: 'Botswana Pula', code: 'BWP' },
        { name: 'Bulgaria Lev', code: 'BGN' },
        { name: 'Brazil Real', code: 'BRL' },
        { name: 'Brunei Darussalam Dollar', code: 'BND' },
        { name: 'Cambodia Riel', code: 'KHR' },
        { name: 'Canada Dollar', code: 'CAD' },
        { name: 'Cayman Islands Dollar', code: 'KYD' },
        { name: 'Chile Peso', code: 'CLP' },
        { name: 'China Yuan Renminbi', code: 'CNY' },
        { name: 'Colombia Peso', code: 'COP' },
        { name: 'Costa Rica Colon', code: 'CRC' },
        { name: 'Croatia Kuna', code: 'HRK' },
        { name: 'Cuba Peso', code: 'CUP' },
        { name: 'Czech Republic Koruna', code: 'CZK' },
        { name: 'Denmark Krone', code: 'DKK' },
        { name: 'Dominican Republic Peso', code: 'DOP' },
        { name: 'East Caribbean Dollar', code: 'XCD' },
        { name: 'Egypt Pound', code: 'EGP' },
        { name: 'El Salvador Colon', code: 'SVC' },
        { name: 'Falkland Islands (Malvinas) Pound', code: 'FKP' },
        { name: 'Fiji Dollar', code: 'FJD' },
        { name: 'Ghana Cedi', code: 'GHS' },
        { name: 'Gibraltar Pound', code: 'GIP' },
        { name: 'Guatemala Quetzal', code: 'GTQ' },
        { name: 'Guernsey Pound', code: 'GGP' },
        { name: 'Guyana Dollar', code: 'GYD' },
        { name: 'Honduras Lempira', code: 'HNL' },
        { name: 'Hong Kong Dollar', code: 'HKD' },
        { name: 'Hungary Forint', code: 'HUF' },
        { name: 'Iceland Krona', code: 'ISK' },
        { name: 'India Rupee', code: 'INR' },
        { name: 'Indonesia Rupiah', code: 'IDR' },
        { name: 'Iran Rial', code: 'IRR' },
        { name: 'Isle of Man Pound', code: 'IMP' },
        { name: 'Israel Shekel', code: 'ILS' },
        { name: 'Jamaica Dollar', code: 'JMD' },
        { name: 'Japan Yen', code: 'JPY' },
        { name: 'Jersey Pound', code: 'JEP' },
        { name: 'Kazakhstan Tenge', code: 'KZT' },
        { name: 'Korea (North) Won', code: 'KPW' },
        { name: 'Korea (South) Won', code: 'KRW' },
        { name: 'Kyrgyzstan Som', code: 'KGS' },
        { name: 'Laos Kip', code: 'LAK' },
        { name: 'Lebanon Pound', code: 'LBP' },
        { name: 'Liberia Dollar', code: 'LRD' },
        { name: 'Macedonia Denar', code: 'MKD' },
        { name: 'Malaysia Ringgit', code: 'MYR' },
        { name: 'Mauritius Rupee', code: 'MUR' },
        { name: 'Mexico Peso', code: 'MXN' },
        { name: 'Mongolia Tughrik', code: 'MNT' },
        { name: 'Mozambique Metical', code: 'MZN' },
        { name: 'Namibia Dollar', code: 'NAD' },
        { name: 'Nepal Rupee', code: 'NPR' },
        { name: 'Netherlands Antilles Guilder', code: 'ANG' },
        { name: 'New Zealand Dollar', code: 'NZD' },
        { name: 'Nicaragua Cordoba', code: 'NIO' },
        { name: 'Nigeria Naira', code: 'NGN' },
        { name: 'Norway Krone', code: 'NOK' },
        { name: 'Oman Rial', code: 'OMR' },
        { name: 'Pakistan Rupee', code: 'PKR' },
        { name: 'Panama Balboa', code: 'PAB' },
        { name: 'Paraguay Guarani', code: 'PYG' },
        { name: 'Peru Sol', code: 'PEN' },
        { name: 'Philippines Peso', code: 'PHP' },
        { name: 'Poland Zloty', code: 'PLN' },
        { name: 'Qatar Riyal', code: 'QAR' },
        { name: 'Romania Leu', code: 'RON' },
        { name: 'Russia Ruble', code: 'RUB' },
        { name: 'Saint Helena Pound', code: 'SHP' },
        { name: 'Saudi Arabia Riyal', code: 'SAR' },
        { name: 'Serbia Dinar', code: 'RSD' },
        { name: 'Seychelles Rupee', code: 'SCR' },
        { name: 'Singapore Dollar', code: 'SGD' },
        { name: 'Solomon Islands Dollar', code: 'SBD' },
        { name: 'Somalia Shilling', code: 'SOS' },
        { name: 'South Africa Rand', code: 'ZAR' },
        { name: 'Sri Lanka Rupee', code: 'LKR' },
        { name: 'Sweden Krona', code: 'SEK' },
        { name: 'Switzerland Franc', code: 'CHF' },
        { name: 'Suriname Dollar', code: 'SRD' },
        { name: 'Syria Pound', code: 'SYP' },
        { name: 'Taiwan New Dollar', code: 'TWD' },
        { name: 'Thailand Baht', code: 'THB' },
        { name: 'Trinidad and Tobago Dollar', code: 'TTD' },
        { name: 'Turkey Lira', code: 'TRY' },
        { name: 'Tuvalu Dollar', code: 'TVD' },
        { name: 'Ukraine Hryvnia', code: 'UAH' },
        { name: 'United Kingdom Pound', code: 'GBP' },
        { name: 'United States Dollar', code: 'USD' },
        { name: 'Uruguay Peso', code: 'UYU' },
        { name: 'Uzbekistan Som', code: 'UZS' },
        { name: 'Venezuela Bolívar', code: 'VEF' },
        { name: 'Viet Nam Dong', code: 'VND' },
        { name: 'Yemen Rial', code: 'YER' },
        { name: 'Zimbabwe Dollar.', code: 'ZWD' }
      ],
      languages: [
        {
          text: 'English',
          value: 'en'
        },
        {
          text: 'Deutsche',
          value: 'de'
        },
        {
          text: 'Gaeilge',
          value: 'ga'
        },
        {
          text: 'Magyar',
          value: 'hu'
        },
        {
          text: 'Íslensku',
          value: 'is'
        },
        {
          text: 'Español',
          value: 'es'
        },
        {
          text: 'Français',
          value: 'fr'
        },
        {
          text: 'русский',
          value: 'ru'
        }
      ],
      buttonLoading: false,
      geoFound: true,
      alert: null
    }
  },
  methods: {
    getLocation() {
      if (navigator.geolocation) {
        this.buttonLoading = true
        setTimeout(() => {
          navigator.geolocation.getCurrentPosition(this.getPosition)
        }, 3000)
      } else {
        this.alert = 'Sorry. Enter these datails manually'
      }
    },
    getPosition() {
      axios
        .get(
          'https://api.ipdata.co?api-key=1c2f33af048503d2cf3f316ea974ece3a94891b0d514cd369d51a1a8',
          {}
        )
        .then(result => {
          this.longitude = result.data.longitude
          this.latitude = result.data.latitude
          this.location = result.data.city
          this.region = result.data.region
          this.country = result.data.country_code
          this.currency = result.data.currency.code
          this.timezone = result.data.time_zone.abbr
          this.buttonLoading = false
          this.geoFound = true
        })
        .catch(err => {
          console.log('error Handle: ', err)
        })
    },
    dismiss() {
      this.longitude = this.$attrs.settings.longitude
      this.latitude = this.$attrs.settings.latitude
      this.location = this.$attrs.settings.location
      this.region = this.$attrs.settings.region
      this.country = this.$attrs.settings.country
      this.currency = this.$attrs.settings.currency
      this.timezone = this.$attrs.settings.timezone
      this.currentLang = this.$attrs.settings.userLang || false
      this.background = this.$attrs.settings.isBlack
      this.$emit('closeDialog')
    },
    update() {
      const payload = {}
      payload.longitude = this.longitude
      payload.latitude = this.latitude
      payload.location = this.location
      payload.region = this.region
      payload.country = this.country
      payload.currency = this.currency
      payload.timezone = this.timezone
      payload.userLang = this.currentLang
      payload.isBlack = this.background
      this.$root.$i18n.locale = this.currentLang
      console.log('Payload from settings: ', payload)
      localStorage.setItem('language', JSON.stringify(this.currentLang))
      this.$store.dispatch('settings/updateSettingsData', payload)
      this.$emit('closeDialog')
      this.backgroundItems[0].name = this.$i18n.t('common.terms.photoBackground')
      this.backgroundItems[1].name = this.$i18n.t('common.terms.photoBackground')
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
